import Image from '@/components/Image';
import { CollapseArrowDownOutlined, EarthOutlined } from '@zeelool/icon';

interface TopBarSiteConfigTriggerProps {
  summary: string;
  flagUrl?: string;
  ariaLabel: string;
}

export function TopBarSiteConfigTrigger({
  summary,
  flagUrl,
  ariaLabel,
}: TopBarSiteConfigTriggerProps) {
  return (
    <button
      type="button"
      className="flex cursor-pointer items-center gap-[4px] border-0 bg-transparent p-0"
      aria-label={`${ariaLabel}: ${summary}`}
    >
      <span className="notranslate whitespace-nowrap text-[12px] leading-[14px] text-white opacity-60">
        {summary}
      </span>
      {flagUrl ? (
        <Image
          src={flagUrl}
          alt=""
          width={16}
          height={16}
          className="size-[16px] shrink-0 rounded-full object-cover"
        />
      ) : (
        <EarthOutlined className="shrink-0 text-[16px] text-white opacity-60" aria-hidden />
      )}
      <CollapseArrowDownOutlined
        className="shrink-0 text-[16px] text-white opacity-60"
        aria-hidden
      />
    </button>
  );
}
